<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#repairSearchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="repairSearchArea" class="panel-collapse collapse in">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">報修學期</label>
              <div class="col-md-8">
                <select v-model="qryParam.smtr" class="form-control">
                  <option value="">--請選擇--</option>
                  <option v-for="(item, index) in selectYear()" :key="index" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">報修地點</label>
              <div class="col-md-8">
                <input v-model="qryParam.repairLocation" type="text" class="form-control" />
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">報修項目</label>
              <div class="col-md-8">
                <select v-model="qryParam.repairItem" class="form-control">
                  <option value="">--請選擇--</option>
                  <option v-for="(item, index) in repairItemList" :key="'repair-item-' + index" :value="item">{{ item }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">報修人</label>
              <div class="col-md-8">
                <input v-model="qryParam.reporterName" type="text" class="form-control" />
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">處理進度</label>
              <div class="col-md-8">
                <select v-model="qryParam.repairStatus" class="form-control">
                  <option value="">--請選擇--</option>
                  <option v-for="(item, index) in statusList" :key="'repair-status-' + index" :value="item">{{ item }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 text-right">
              <div class="col-xs-5 col-md-4 col-md-offset-2">
                <button type="button" class="btn btn-default btn-block" @click="clearSearch">清空</button>
              </div>
              <div class="col-xs-5 col-md-4 col-xs-offset-2 col-md-offset-2">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">報修管理</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-12 text-right">
            <button v-if="canCreate" type="button" class="btn btn-danger hidden-xs" @click="goCreate">新增</button>
            <button v-if="canCreate" type="button" class="btn btn-danger btn-block visible-xs" @click="goCreate">新增</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="11%">報修學期</th>
                  <th class="text-center" width="19%">報修地點</th>
                  <th class="text-center" width="11%">報修項目</th>
                  <th class="text-center" width="13%">報修日期</th>
                  <th class="text-center" width="20%">可修繕時間</th>
                  <th class="text-center" width="11%">房內人員</th>
                  <th class="text-center" width="8%">報修人</th>
                  <th class="text-center" width="7%">處理進度</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!repairList.length">
                  <td class="text-center" colspan="8">查無資料</td>
                </tr>
                <tr v-for="(item, index) in repairList" :key="index">
                  <td class="text-center" data-title="報修學期">{{ formatSmtr(item.smtr) }}</td>
                  <td class="text-center" data-title="報修地點">{{ item.repairLocation }}</td>
                  <td class="text-center" data-title="報修項目">{{ item.repairItem }}</td>
                  <td class="text-center" data-title="報修日期">{{ item.reportDateStr }}</td>
                  <td data-title="可修繕時間">{{ item.availableTimeText || "-" }}</td>
                  <td data-title="房內人員">{{ item.roomOccupantsText || "-" }}</td>
                  <td class="text-center" data-title="報修人">{{ item.reporterName }}</td>
                  <td class="text-center" data-title="處理進度">
                    <a href="javascript:;" class="btn btn-link" @click="goDetail(item)">{{ item.repairStatus }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center">
              <pageControl :page="page" :total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

export default {
  data() {
    return {
      repairList: [],
      repairItemList: [],
      statusList: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      defaultSmtr: "",
      qryParam: {
        smtr: "",
        repairLocation: "",
        repairItem: "",
        reporterName: "",
        repairStatus: "",
      },
    };
  },
  computed: {
    canCreate() {
      return this.sessionData && this.sessionData.isRoomMage === "Y" && !this.isAdmin("stay");
    },
  },
  methods: {
    guardAccess() {
      if (this.isAdmin("stay") || this.canCreate) {
        return true;
      }
      bootbox.alert("無報修管理權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },
    selectYear() {
      let smtrArray = [];
      let nowYear = new Date().getFullYear() - 1911;
      let nowMonth = new Date().getMonth() + 1;
      if (nowMonth < 8) {
        nowYear = nowYear - 1;
      }
      for (let y = nowYear; y > 100; y--) {
        if ((y === nowYear && nowMonth < 8) || y < nowYear) {
          smtrArray.push({ text: y + "年第二學期", value: y + "2" });
        }
        smtrArray.push({ text: y + "年第一學期", value: y + "1" });
      }
      return smtrArray;
    },
    formatSmtr(smtr) {
      if (!smtr || smtr.length !== 4) {
        return smtr || "";
      }
      const year = smtr.substring(0, 3);
      const term = smtr.substring(3, 4) === "1" ? "第一學期" : "第二學期";
      return year + "年" + term;
    },
    restoreSearch() {
      const storeQryParam = JSON.parse(this.getStore(this.$route.name + ".qryParam"));
      if (storeQryParam) {
        this.qryParam.smtr = storeQryParam.smtr || "";
        this.qryParam.repairLocation = storeQryParam.repairLocation || "";
        this.qryParam.repairItem = storeQryParam.repairItem || "";
        this.qryParam.reporterName = storeQryParam.reporterName || "";
        this.qryParam.repairStatus = storeQryParam.repairStatus || "";
        this.page = storeQryParam.page || 1;
      }
    },
    loadInit(callback) {
      const api = "/api/DormitoryRepair/init";
      this.$axios.get(api).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "取得報修初始化資料失敗");
          return;
        }

        const initData = resp.data.data || {};
        this.repairItemList = initData.repairItemList || [];
        this.statusList = initData.statusList || [];
        this.defaultSmtr = initData.defaultSmtr || "";

        if (!this.qryParam.smtr) {
          if (this.defaultSmtr) {
            this.qryParam.smtr = this.defaultSmtr;
          } else {
            const years = this.selectYear();
            if (years.length > 0) {
              this.qryParam.smtr = years[0].value;
            }
          }
        }

        if (callback) {
          callback();
        }
      });
    },
    buildSearchRequest() {
      return {
        page: this.page,
        pageSize: this.pageSize,
        model: {
          smtr: this.qryParam.smtr,
          repairLocation: this.qryParam.repairLocation,
          repairItem: this.qryParam.repairItem,
          reporterName: this.qryParam.reporterName,
          repairStatus: this.qryParam.repairStatus,
        },
      };
    },
    updateGrid(page) {
      this.page = page;
      this.getGridData();
    },
    getGridData() {
      this.setStore(this.$route.name + ".qryParam", {
        smtr: this.qryParam.smtr,
        repairLocation: this.qryParam.repairLocation,
        repairItem: this.qryParam.repairItem,
        reporterName: this.qryParam.reporterName,
        repairStatus: this.qryParam.repairStatus,
        page: this.page,
      });

      const api = "/api/DormitoryRepair/grid";
      this.$axios.post(api, JSON.stringify(this.buildSearchRequest())).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "取得報修清單失敗");
          return;
        }

        this.repairList = resp.data.data.rows || [];
        this.totalPage = resp.data.data.total || 0;
        this.page = resp.data.data.page || this.page;
      });
    },
    clearSearch() {
      this.qryParam = {
        smtr: this.defaultSmtr,
        repairLocation: "",
        repairItem: "",
        reporterName: "",
        repairStatus: "",
      };
      this.page = 1;
    },
    goCreate() {
      this.removeStore("stay.repair.edit");
      this.$router.push({ name: "stay.repair.edit" });
    },
    goDetail(item) {
      this.setStore("stay.repair.edit", { id: item.id });
      this.$router.push({ name: "stay.repair.edit", query: { id: item.id } });
    },
  },
  mounted() {
    if (!this.guardAccess()) {
      return;
    }
    this.restoreSearch();
    this.loadInit(() => {
      this.getGridData();
    });
  },
};
</script>
